const binding = { modules: {}, dataActions: {} };

    (binding.modules['language-toggle'] = {
        c: () => require('partner/modules/language-toggle/language-toggle.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'language-toggle',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/language-toggle'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|language-toggle|language-toggle'] = {
                c: () => require('partner/modules/language-toggle/language-toggle.view.tsx'),
                cn: '__local__-__local__-language-toggle'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };